module.exports = __webpack_public_path__ + "img/sm-inb.743d03d4.svg";